<template>
  <div class="dashboard-container wrap_over">
    <div class="dashboard-text">歡迎使用快遞代收管理系統<span class="dashboard-text-version">(v-{{packageJSON.version}})</span></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { dispatcherLogin } from '@/api/user'
const packageJSON = require('../../../package.json')

export default {
  name: 'dashboard',
  data () {
    return {
      packageJSON: packageJSON
    }
  },
  methods: {
    // riderLogin () {
    //   let params = {
    //     userName: 'r11',
    //     password: '111111',
    //     channel: 9
    //   }
    //   dispatcherLogin({
    //     params,
    //     baseURL: 'http://test.rider.miguatech.com/aomi-rider'
    //   })
    //     .then(result => {
    //       console.log('骑手登錄：', result)
    //     })
    //     .catch(err => {})
    // }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
    &-version {
      font-size: 18px;
    }
  }
}
</style>
